import React, { FC } from 'react';

import Grid from '@mui/material/Grid';

import PageHeader from '../../../sharedModules/layout/PageHeader';
import CreateNewSubmissionCard from '../../existingCustomerSubmission/components/CreateNewSubmissionCard';

const NewCustomerPage: FC = () => {
  return (
    <Grid container rowSpacing={2}>
      <Grid item xs={12}>
        <PageHeader mainTitle="Energy Solutions" subTitle="New Customer" />
      </Grid>
      <Grid item xs={12}>
        <CreateNewSubmissionCard />
      </Grid>
    </Grid>
  );
};

export default NewCustomerPage;
